/* eslint-disable i18next/no-literal-string -- styles not user facing */
import { defineSlotRecipe } from '@chakra-ui/react';

export const result = defineSlotRecipe({
  slots: ['container', 'icon', 'title', 'text'],
  base: { container: { textAlign: 'center' }, text: { color: 'fg.muted' } },
  variants: {
    size: {
      sm: {
        container: {
          paddingX: 2,
          paddingY: 3,
        },
        icon: { boxSize: '20px' },
        title: { fontSize: 'lg' },
        text: { fontSize: 'md' },
      },
      md: {
        container: {
          paddingX: 4,
          paddingY: 6,
        },
        icon: { boxSize: '35px' },
        title: { fontSize: '2xl' },
        text: { fontSize: 'md' },
      },
      lg: {
        container: {
          paddingX: 6,
          paddingY: 10,
        },
        icon: { boxSize: '50px' },
        title: { fontSize: '4xl' }, //4xl =  30
        text: { fontSize: 'lg' },
      },
    },
  },

  defaultVariants: { size: 'lg' },
});
